module.exports = __webpack_public_path__ + "static/about-two-f9d807adf77189ffba9693242117cef7.jpg";